import { isEmpty, isNull } from 'lodash'
import { GetUploadedDocsQueryVariables, Individual, Maybe } from '../../graphql'
import { DocumentPageStateType } from '../../types'
import { formatDate } from '../../utils/dateUtils'

export const updateDocQueryParams = (
  state: DocumentPageStateType,
  queryParams: GetUploadedDocsQueryVariables,
) => {
  const updatedParams = { ...queryParams }

  const { searchValue, documentType, period } = state

  if (searchValue) {
    updatedParams.search = searchValue
  } else {
    delete updatedParams.search
  }

  if (!isEmpty(documentType)) {
    updatedParams.types = documentType as never[]
  } else {
    delete updatedParams.types
  }

  if (!period.some(isNull)) {
    const [from, to] = period

    const day = 24 * 60 * 60 * 1000
    const updatedFromDate = new Date(formatDate(from, true)).setHours(24) - day
    const fromDate = new Date(updatedFromDate).toISOString()
    const updatedToDate = new Date(formatDate(to, true)).setHours(24)
    const toDate = new Date(updatedToDate).toISOString()

    updatedParams.creationTimeFrom = fromDate
    updatedParams.creationTimeTo = toDate
  } else {
    delete updatedParams.creationTimeFrom
    delete updatedParams.creationTimeTo
  }

  return updatedParams
}

export const getFullName = (person: Maybe<Individual> | undefined) =>
  person ? `${person.firstName} ${person.lastName && person.lastName}`.trim() : ''
